import WebLayout from "../layout/WebLayout";
import { Link } from "react-router-dom";

function Seller() {
  return (
    <WebLayout pageName={Seller}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0"
          >
            <div className="mb-20">
              <h6 className="mb-10">
                IndianMSME.org Terms and conditions for Manufacturer Seller
              </h6>
              <p className="mb-2">
                IndianMSME.org provides a seamless B2B marketplace for all
                manufacturers to sell their products across India. By
                registering as a Manufacturer Seller, you agree to the following
                terms:
              </p>
              <h6 className="mt-10 mb-10">1. Registration & Eligibility</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  All manufacturers, including MSMEs across all categories, are
                  eligible to sell through IndianMSME.org.
                </li>
                <li>
                  MSME Manufacturer Sellers must be registered MSMEs with valid
                  UDYAM Registration, GSTIN, PAN, and Bank Details.
                </li>
                <li>
                  Manufacturer Sellers must provide accurate business details
                  during the onboarding process.
                </li>
                <li>
                  IndianMSME.org reserves the right to verify and approve
                  Manufacturer Seller registrations.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">2. Product Listing & Compliance</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Manufacturer Sellers must list accurate product details,
                  including specifications, pricing, and stock availability.
                </li>
                <li>
                  All products must comply with quality and legal standards
                  applicable in India.
                </li>
                <li>
                  IndianMSME.org reserves the right to remove or modify listings
                  that violate platform policies.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">3. Pricing Policy</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Manufacturer Sellers must provide an Ex-Factory Price
                  (Exclusive of Logistics) for all listed products.
                </li>
                <li>
                  IndianMSME.org will bill buyers with a margin (including
                  logistics expenses) added over the Ex-Factory Price before
                  invoicing.
                </li>
                <li>
                  Price fluctuations must be informed in advance to avoid order
                  cancellations or discrepancies.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">
                4. Order Fulfillment & Stock Availability
              </h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Manufacturer Sellers will receive B2B orders from buyers via
                  IndianMSME.org.
                </li>
                <li>
                  Upon receiving an order, the Manufacturer Seller must confirm
                  stock availability and keep the stock ready for dispatch.
                </li>
                <li>
                  Manufacturer Sellers must immediately inform IndianMSME.org
                  once the stock is ready for pickup.
                </li>
                <li>
                  Delay or failure to provide stock for confirmed orders may
                  result in account suspension or penalties.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">5. Logistics & Delivery</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  IndianMSME.org will handle all logistics and arrange order
                  pickups from the Manufacturer Seller’s location.
                </li>
                <li>
                  Manufacturer Sellers must ensure proper packaging as per
                  IndianMSME.org’s shipping guidelines.
                </li>
                <li>
                  Any damage due to improper packaging will be the Manufacturer
                  Seller’s responsibility.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">6. Payment Terms</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  IndianMSME.org will bill buyers with a margin and collect
                  payments directly.
                </li>
                <li>
                  Payments to Manufacturer Sellers will be processed post
                  successful delivery, as per the agreed payment cycle.
                </li>
                <li>
                  Manufacturer Sellers will receive payments after deducting
                  platform charges and applicable taxes.
                </li>
                <li>
                  Any disputes related to payment must be raised within 7 days
                  of the transaction.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">7. Returns & Disputes</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Returns will be handled as per the IndianMSME.org Return &
                  Cancellation Policy.
                </li>
                <li>
                  If a product is defective, damaged, or does not meet the order
                  specifications, the Manufacturer Seller must replace or refund
                  the item.
                </li>
                <li>
                  Any disputes must be resolved through IndianMSME.org grievance
                  redressal system before legal action.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">8. Promotions & Display Support</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  Manufacturer Sellers can opt for display space at Ardh Sainik
                  Malls & Canteens for better product visibility at each
                  District level.
                </li>
                <li>
                  Digital marketing services are available to promote
                  Manufacturer Seller products across various channels.
                </li>
              </ul>
              <h6 className="mt-10 mb-10">7. Termination & Compliance</h6>
              <ul style={{ listStyle: "lower-latin", paddingLeft: "20px" }}>
                <li>
                  IndianMSME.org reserves the right to suspend or terminate
                  Manufacturer Seller accounts for:
                  <ul className="mt-10">
                    <li className="text-gray-400 mb-14 flex-align gap-14">
                      <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                        <i className="ph ph-check"></i>
                      </span>
                      <span className="text-heading fw-medium">
                        I. Non-compliance with platform policies..
                      </span>
                    </li>
                    <li className="text-gray-400 mb-14 flex-align gap-14">
                      <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                        <i className="ph ph-check"></i>
                      </span>
                      <span className="text-heading fw-medium">
                        II. Repeated stock unavailability for confirmed orders.
                      </span>
                    </li>
                    <li className="text-gray-400 mb-14 flex-align gap-14">
                      <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                        <i className="ph ph-check"></i>
                      </span>
                      <span className="text-heading fw-medium">
                        III. Violation of product quality standards.
                      </span>
                    </li>
                  </ul>
                </li>
                <li>
                  Manufacturer Sellers must comply with all tax and legal
                  requirements related to sales and invoicing.
                </li>
              </ul>
            </div>
            <p className="mb-10">
              By registering as a Manufacturer Seller on IndianMSME.org, you
              agree to comply with these terms and conditions to ensure a smooth
              and transparent business experience.
            </p>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg shadow-md text-center">
            <h3 className="text-lg font-semibold text-gray-700 mb-2">
              For Assistance, Contact:
            </h3>
            <div className="flex flex-col gap-2">
              <Link
                to="mailto:help@indianmsme.org"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📧 help@indianmsme.org
              </Link>
              <Link
                to="tel:9990060509"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📞 +91-9990060509
              </Link>
              <Link
                to="tel:8800001242"
                className="py-2 px-4 rounded-lg shadow-md"
              >
                📞 +91-8800001242
              </Link>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Seller;
